module.exports = __webpack_public_path__ + "img/tiktok.624fa0c6.svg";